module.exports = __webpack_public_path__ + "img/sanSebastian.4709e080.jpg";